import React from 'react';

const ConfirmationModal = ({ title ,isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
            <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                <div className="flex justify-center text-[#2776c3] font-semibold text-[20px] pb-5 pt-3" style={{ fontFamily: 'Liberation Serif' }}>
                    {title}
                </div>

                <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                    <div
                        className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                        onClick={onClose}
                    >
                        No
                    </div>
                    <div
                        className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                        onClick={onConfirm}
                    >
                        Confirm
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;